import http from "./index"
function getData(params) {
    return http.post('/article/where', params)
}
function getBannerList(params) {
    return http.post('/banner/selectKingBanner', params)
}

function getTbData(params) {
    return http.get('/TaiBaoNews?id=' + params.id, params)
}

export default {
    getTbData,
    getData,
    getBannerList
}


// WEBPACK FOOTER //
// ./src/api/api.js